import React from 'react';
import { connect } from 'react-redux';
import { shape, string } from 'prop-types';
import { Heading } from '@tesla/design-system-react';
import Selectors from '~/common/redux/selectors/index';

import styles from './styles.module.css';

const NameAndEmailBlock = ({
  nameValue,
  emailValue,
  commonTranslations: { email, fullName, na, transferTo },
}) => {
  return (
    <div className={styles.Container} data-test="remove-name-and-email-block">
      <Heading
        is="h2"
        looksLike="h5"
        className={styles.TransferTo}
        data-test="remove-name-and-email-block-title"
      >
        {transferTo}
      </Heading>
      <div className={styles.TitleAndText}>
        <div className={styles.Title}>
          <p
            className={`tds-text--medium ${styles.TitleText}`}
            data-test="remove-name-and-email-block-name-title"
          >
            {fullName}
          </p>
        </div>
        <p
          className={`tds-text--medium ${styles.Content}`}
          data-test="remove-name-and-email-block-name-value"
        >
          {nameValue || na}
        </p>
      </div>
      <div className={styles.TitleAndText}>
        <div className={styles.Title}>
          <p
            className={`tds-text--medium ${styles.TitleText}`}
            data-test="remove-name-and-email-block-email-title"
          >
            {email}
          </p>
        </div>
        <p
          className={`tds-text--medium ${styles.Content}`}
          data-test="remove-name-and-email-block-email-value"
        >
          {emailValue || na}
        </p>
      </div>
    </div>
  );
};

NameAndEmailBlock.propTypes = {
  nameValue: string,
  emailValue: string,
  commonTranslations: shape({}).isRequired,
};

NameAndEmailBlock.defaultProps = {
  nameValue: '',
  emailValue: '',
};

export default connect(
  Selectors,
  null
)(NameAndEmailBlock);
